export const state = {
  track: {},
  needsToUpdate: false
};
